import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_CATEGORY_LIST_FAIL =
  "SHOP:GET_PRODUCT_CATEGORY_LIST_FAIL";

export const getProductCategoryListFailAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_PRODUCT_CATEGORY_LIST_FAIL as typeof GET_PRODUCT_CATEGORY_LIST_FAIL,
  organization,
});

export type GetProductCategoryListFailAction = ReturnType<
  typeof getProductCategoryListFailAction
>;
